import { Phone, Mail } from "lucide-react";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0B0C0E]">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <LogoMark />
          <span className="font-display text-2xl font-black tracking-tight text-[#F3F4F6]">
            GATIVAN<span className="text-[#FFFFFF]">.</span>
          </span>
        </div>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#9CA3AF]">
          Gativan Office — contracting &amp; engineering for electrical, plumbing and bespoke furniture
          since 2019.
        </p>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FFFFFF]">Navigate</p>
        <div className="mt-5 flex flex-col gap-3">
          {[
            ["About", "#about", "footer-link-about"],
            ["Services", "#services", "footer-link-services"],
            ["Projects", "#projects", "footer-link-projects"],
            ["Contact", "#contact", "footer-link-contact"],
          ].map(([label, href, testid]) => (
            <a key={href} href={href} data-testid={testid} className="text-sm text-[#9CA3AF] transition-colors hover:text-[#FFFFFF]">
              {label}
            </a>
          ))}
        </div>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FFFFFF]">Reach us</p>
        <div className="mt-5 space-y-3">
          <a
            href="tel:+917709322253"
            data-testid="footer-phone-link"
            className="flex items-center gap-3 text-sm text-[#9CA3AF] transition-colors hover:text-[#FFFFFF]"
          >
            <Phone size={15} className="text-[#FFFFFF]" /> +91 77093 22253
          </a>
          <a
            href="mailto:gativan55@gmail.com"
            data-testid="footer-email-link"
            className="flex items-center gap-3 text-sm text-[#9CA3AF] transition-colors hover:text-[#FFFFFF]"
          >
            <Mail size={15} className="text-[#FFFFFF]" /> gativan55@gmail.com
          </a>
          <p className="pt-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#6B7280]">
            Founder · Vinod Tripathy
          </p>
          <p className="text-xs leading-relaxed text-[#9CA3AF]">
            Shop No 6, Shantinath Vaibhav Building, Chardhar Nagar, Hanuman Nagar Road, Nallasopara West,
            Maharashtra 401203
          </p>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-[#6B7280]">
      © 2026 Gativan Office · Engineered in India
    </div>
  </footer>
);
